import { render, staticRenderFns } from "./UserLogout.vue?vue&type=template&id=f860d994&"
import script from "./UserLogout.vue?vue&type=script&lang=js&"
export * from "./UserLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports